import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
// import HomeCarousel1 from './HomeCarousel'

const Hero = () => {
  return <main className='home-main'>

 <Wrapper className='section-center circles-container'>
                <div className='circle1'></div>
                <div className='circle2'></div>
                 <div className='circle3'></div>
             <article >
                  <h1 className='home-h1'><span>Online</span> Shopping <br></br>Made Easy</h1>
                  <p className='hero-p'>It's more comfortable to buy something from a professionally looking website equipped with all the necessary options like this one.</p>
                  <Link to='products' className='btn hero-btn'>Shop Now</Link>
              </article>
              <article className='img-container'>
                   <img src="./images/bag-shoes.jpg" alt="Bag and shoes" className='main-img'></img>
                 {/* <HomeCarousel1 className='main-image'></HomeCarousel1> */}
                 <img src="./images/all-star.jpg" alt="Shoes" className='accent-img'></img>
              </article>

         </Wrapper>
         </main>
}

const Wrapper = styled.section`
  min-height: 60vh;
  display: grid;
  place-items: center;
  .img-container {
    display: none;
  }
.hero-p{
  background-color:white;
  padding:1rem;
  border-radius:0.3rem;
}
  p {
    line-height: 2;
    max-width: 45em;
    margin-bottom: 2rem;
    color: var(--clr-grey-5);
    font-size: 1rem;
  }

  .hero-btn{
 background-color:rgb(237, 182, 72);
 position: relative;
 z-index: 1;
 margin-bottom:2rem;
  }

   .hero-btn:hover{
 background-color:rgb(237, 72, 152);
 color:white;
  }

  @media (min-width: 992px) {
    height: calc(100vh - 5rem);
    grid-template-columns: 1fr 1fr;
    gap: 8rem;
    h1 {
      margin-bottom: 2rem;
    }
    p {
      font-size: 1.25rem;
    }
    .hero-btn {
      padding: 0.75rem 1.5rem;
      font-size: 1rem;
       margin-bottom:0;
      background-color:rgb(138, 12, 126);
      color:white;
    }

    .hero-btn:hover {
     color:white;
     background-color:rgb(237, 72, 152);
    }
    .img-container {
      display: block;
      position: relative;
    }
    .main-img {
      width: 100%;
      height: 550px;
      /* height:30rem; */
      position: relative;
      border-radius: var(--radius);
      display: block;
      object-fit: cover;
     
    }
    .accent-img {
      box-shadow: 0 0 0.3rem rgba(207, 39, 193, 0.9);
      position: absolute;
      bottom: 0;
      left: 0;
      width: 250px;
      width:350px;
      transform: translateX(-50%);
      border-radius: var(--radius);
    }
    .img-container::before {
      content: '';
      position: absolute;
      width: 10%;
      height: 80%;
      height:90%;
      background: rgb(181, 26, 163);
      bottom: 0%;
      left: -8%;
      border-radius: var(--radius);
    }
  }
`

export default Hero
